var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighDefinition = function SvgHighDefinition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    className: "highDefinition_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M213.333 298.667h85.334v170.666H384V298.667h85.333v426.666H384V554.667h-85.333v170.666h-85.334zm341.334 0h128a128 128 0 0 1 128 128v170.666a128 128 0 0 1-128 128h-128zm128 341.333a42.667 42.667 0 0 0 42.666-42.667V426.667A42.667 42.667 0 0 0 682.667 384H640v256z"
  })));
};
export default SvgHighDefinition;